// extracted by mini-css-extract-plugin
module.exports = {"tabList":"_3xpxokoW63_calculator","tab":"_1NFYfOSndm_calculator","s":"_2g1x8G1dVD_calculator","m":"_2k9cBhlYiG_calculator","l":"_3vgVzAXuVy_calculator"};